export const styles = theme => ({
    search: {
        "& input": {
            padding: "14px 14px"
        }
    },
    table: {
        "& div": {
            backgroundColor: "#fff"
        },
        "& th": {
            fontWeight: 600
        },
        "& tr": {
            fontSize: 15
        },
        "& .MuiInputAdornment-positionStart": {
            padding: 15
        }
    },
    select: {
        width: "80%",
    },
    inputField: {
        width: "80%"
    },
    link: {
        cursor: "pointer"
    },
    priceField: {
        minWidth: 100
    }
});
